(function () {
    'use strict';

    angular.module('app').component('clinicPanelDashboardAverageClaimPriceRangeComponent', {
        templateUrl: require('/App/clinic/views/panelDashboard/averageClaimPriceRange/averageClaimPriceRange.component.html'),
        controller: ['$uibModal', 'abp.services.app.panelDashboard', controller],
        controllerAs: 'vm',
        bindings: {
            panelLocationId: '<',
            isGpPanel: '<'
        }
    });

    function controller($uibModal, panelDashboardSvc) {
        var vm = this;

        vm.$onChanges = onChanges;
        vm.onTable = onTable;

        vm.header = App.localize('AverageClaimPriceRange');
        vm.growthDuration = App.localize('FromSameDayLastMonth');
        vm.tooltip = App.localize('AverageClaimPriceRangeTooltip');
        vm.hasGpDashboardEnhancement = abp.setting.getBoolean('Hms.Feature.GPDashboardEnhancement');

        function onChanges(changes) {
            if (changes.panelLocationId && changes.panelLocationId.currentValue) {
                getAverageClaimPriceRangeMetric();
            }
        }

        function getAverageClaimPriceRangeMetric() {
            vm.loading++;
            panelDashboardSvc.getAverageClaimPriceRangeMetric({ id: vm.panelLocationId })
                .success(function (data) {
                    vm.metrics = data.metrics;
                    vm.growthRate = data.growthRate;
                    vm.momGrowthResult = data.momGrowthRate;
                    _.map(vm.momGrowthResult, function (r) {
                        var lowerBoundary = Math.floor(r.metricValue / 10) * 10;
                        var upperBoundary = Math.ceil((r.metricValue + 1) / 10) * 10 - 1;
                        r.metricValue = lowerBoundary + " - " + upperBoundary;
                    });
                })
                .finally(function () {
                    vm.loading--;
                });
        }

        function onTable() {
            $uibModal.open({
                component: 'clinicPanelDashboardGrowthTable',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    result: function () {
                        return vm.momGrowthResult;
                    },
                    type: function () {
                        return "averageClaimPriceRange";
                    },
                    header: function () {
                        return vm.header;
                    }
                }
            });
        }
    }
})();
